<template>
    <div class="page">
          <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="门店">
                <GridSelectLi
                    style="width: 200px"
                    title="选择门店"
                    labelName="storeName"
                    labelValue="id"
                    :value="queryForm.id"
                    :limit="1"
                    size="small"
                    placeholder="请选择门店"
                    @getValue="getSearchValueStoreId"
                    :columns="STORE_code"
                    :searchs="STORE_search"
                    dataListUrl="/shop/store/findList"
                    entityBeanName="shopStore"
                    queryEntityUrl="/shop/store/get"
                >
                </GridSelectLi>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStorePayOrderList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>

        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-plus"
                        @click="showDialog = true"
                    >添加门店</el-button>
                </div>
                <div class="icon-group">
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span
                        class="icon-box"
                        @click="refreshShopStorePayOrderList"
                    >
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopStorePayOrderList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size="small"
            >
                <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="storeName"
                label="门店名称"
                > </el-table-column>

                <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="storeLogo"
                label="门店logo"
                > 
                    <template slot-scope="scope">
                        <div  style="display: flex;justify-content: center;align-items: center;">
                            <el-image v-if='scope.row.storeLogo' style="width: 60px; height: 60px" :src="scope.row.storeLogo" :preview-src-list="[scope.row.storeLogo]" />
                            <img v-else style="width: 60px; height: 60px" src="@/assets/img/App.png"></img> 
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="userNickname"
                label="用户昵称"
                > </el-table-column>
                <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="userName"
                label="姓名"
                > </el-table-column>
                <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="userMobile"
                label="手机号"
                > </el-table-column>
                <el-table-column
                :show-overflow-tooltip="true"
                align="center"
                prop="licenseName"
                label="营业执照名称"
                > </el-table-column>
                <el-table-column
                fixed="right"
                align="center"
                label="操作"
                >
                <template slot-scope="scop">
                    <div class="operation">
                    <div @click="deleteShopStorePayOrder(scop.row.id)">
                        <Icon size="16" style="color: red">
                        <Delete24Regular />
                        </Icon>
                        <span class="operation-label" style="color: red">删除</span>
                    </div>
                    </div>
                </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                @size-change="sizeChange"
                @current-change="currentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                background
                :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 添加门店 -->
            <el-dialog
                title="添加门店"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopStorePayOrder"
                        ref="shopStorePayOrderForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                        label="门店"
                        prop="storeId"
                        >
                            <GridSelectLi
                                style="width: 177px"
                                title="选择门店"
                                labelName="storeName"
                                labelValue="id"
                                :value="shopStorePayOrder.storeId"
                                :limit="1"
                                size="small"
                                placeholder="请选择门店"
                                @getValue="getValueStoreId"
                                :columns="STORE_code"
                                :searchs="STORE_search"
                                dataListUrl="/shop/store/findList"
                                entityBeanName="shopStore"
                                queryEntityUrl="/shop/store/get"
                            >
                            </GridSelectLi>
                        </el-form-item>
                    </el-form>
                </div>
        
                <div
                slot="footer"
                class="flex justify-end"
                >
                <el-button @click="closeDialog">关闭</el-button>
                <el-button
                    type="primary"
                    @click="submitForm"
                >确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
  </template>
  
  <script>
  import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
  import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
  import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
  import { get, post, deleteFun } from '@/utils/request.js';
  import GridSelectU from '@/components/gridselect/index.vue';
  import GridSelectLi from '@/components/gridselect/gidselect.vue';
  import { STORE, STORE_SEARCH, USER, USER_SEARCH } from '@/utils/constant';
  
  export default {
      components: {
          GridSelectLi,
          GridSelectU,
          Edit24Regular,
          Delete24Regular,
          Eye24Regular,
          GridDots,
          Refresh,
          Printer,
          ArrowUp,
          ArrowDown,
          ArrowDownload24Regular,
          ArrowExportUp24Regular,
          Search
      },
      data() {
              return {
                  queryForm:{
                       id: '', //门店ID
                  },
                  loading: false,
                  showDialog: false,
                  isSearch: false,
                  pageSize: 10,
                  currentPage: 1,
                  totalNum: 0,
                  STORE_code: STORE,
                  STORE_search: STORE_SEARCH,
                  USER_code: USER,
                  USER_search: USER_SEARCH,
                  shopStorePayOrderList: [],
                  shopStorePayOrder: {
                      id: '', //门店ID
                  },
                  rules: {
                      id: [{ required: true, message: '门店ID不能为空', trigger: 'blur' }],
                  },
              };
          },
          created() {
              this.getShopStorePayOrderList();
          },
          methods: {
            //   搜索box
              search(){
                  this.isSearch = !this.isSearch;
              },
              resetShopStorePayOrderList() {
                  this.pageSize = 10;
                  this.currentPage = 1;
                  this.shopStorePayOrderList = [];
              },
              resetDialog() {
                  this.showDialog = false;
                  this.queryForm.id = '';
                  this.getShopStorePayOrderList();
              },
              closeDialog() {
                  this.showDialog = false
                  this.shopStorePayOrder = {
                        id: '', //门店ID
                  };
              },
              submitForm() {
                this.$refs.shopStorePayOrderForm.validate((valid) => {
                    if (valid) {
                        post(`/store/subsidy/add`,{ ...this.shopStorePayOrder }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetShopStorePayOrderList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
              },
            //   新增选择门店id
              getValueStoreId(value){
                  this.shopStorePayOrder.id = value
              },
            //   搜索选择门店id
              getSearchValueStoreId(value){
                  this.queryForm.id = value
              },
            //   删除
              deleteShopStorePayOrder(id) {
                  this.$confirm('确定删除所选项吗？', '提示', {
                      type: 'warning'
                  })
                      .then(() => {
                          get(`/store/subsidy/deleteById`,{ id:id }).then((res) => {
                              if (res.success) {
                                  this.$message({
                                      message: res.msg,
                                      type: 'success',
                                      duration: 2000
                                  });
                                  this.resetShopStorePayOrderList();
                                  this.getShopStorePayOrderList();
                              } else {
                                  this.$message({
                                      message: res.msg,
                                      type: 'error',
                                      duration: 2000
                                  });
                              }
                          });
                      })
                      .catch(() => {});
              },
              refreshShopStorePayOrderList() {
                  this.resetShopStorePayOrderList();
                  this.getShopStorePayOrderList();
              },
            //   获取列表信息
              getShopStorePayOrderList() {
                  this.loading = true;
                  get(`/store/subsidy/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                      this.loading = false;
                      if (res.success) {
                          this.shopStorePayOrderList = res.page.list;
                          this.totalNum = res.page.total;
                      } else {
                          this.$message({
                              message: res.msg,
                              type: 'error',
                              duration: 2000
                          });
                      }
                  });
              },
              currentChange(page) {
                  this.currentPage = page;
                  this.getShopStorePayOrderList();
              },
              sizeChange(size) {
                  this.pageSize = size;
                  this.getShopStorePayOrderList();
              }
          }
  
  };
  </script>
  
  <style lang="scss" scoped>
  ::v-deep .el-dialog__header {
      border-bottom: 1px solid #eee;
  }
  .operation {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #409eff;
      font-size: 12px;
  
      & > div {
          display: flex;
          align-items: center;
          padding: 0 5px;
          cursor: pointer;
      }
  
      .operation-label {
          margin-left: 3px;
      }
  }
  .count{
      font-size: 14px;
      margin-left: 10px;
      padding: 0 4px;
  }
  </style>